// 追梦中国相关页面
export var ROUTE_NAME = {
  DREAM_INDEX: 'DREAM_INDEX',
  DREAM_DETAIL: 'DREAM_DETAIL',
  DREAM_RUNNERS: 'DREAM_RUNNERS',
  DREAM_HOME: 'DREAM_HOME',
  DREAM_CITYMAP: 'DREAM_CITYMAP',
  DREAM_SCENE: 'DREAM_SCENE',
  DREAM_RANK: 'DREAM_RANK',
  DREAM_ATLAS: 'DREAM_ATLAS',
  DREAM_HISTORY: 'DREAM_HISTORY',
  DREAM_ROUTE_DETAIL: 'DREAM_ROUTE_DETAIL',
  DREAM_REAL_NAME_VERIFY: 'DREAM_REAL_NAME_VERIFY',
  DREAM_STRATEGY: 'DREAM_STRATEGY',
  DREAM_DIGITAL_DETAIL: 'DREAM_DIGITAL_DETAIL',
  DREAM_COLLECTION: 'DREAM_COLLECTION',
  DREAM_SPECIAL_RANK: 'DREAM_SPECIAL_RANK',
  DREAM_JOIN: 'DREAM_JOIN',
  DREAM_INVITE: 'DREAM_INVITE',
  DREAM_INVITE_SELF: 'DREAM_INVITE_SELF',
  DREAM_INVITE_RANK: 'DREAM_INVITE_RANK',
  DREAM_DIGITAL: 'DREAM_DIGITAL'
};
/** 当前页面 图鉴详情弹窗 包括两个参数类型和id */

export var STORE_KEY_CURRENT_POPUP = 'STORE_KEY_CURRENT_POPUP';
export var GAME_RULE = [{
  title: '关于报名：',
  content: ['点击【赛事详情页】页面下方“我要报名”进入选择套餐报名环节，多种套餐供你选择，付费成功报名成功。', '游戏自9月1日起，随时可报名，报名成功并在游戏开启后，即可立即开始游戏。', '2022年10月3日游戏开启，且每周一开启一个新地图，地图开启后有效期为7天（周一至周日）。', '每个用户仅限使用1个账号参与追梦中国游戏活动（同一百日跑账号、手机号、移动设备、银行卡、支付账号、身份证以及其他信息相同均视为同一账号）']
}, {
  title: '收货地址：',
  content: ['支付完成，在收货地址页面可以添加收货地址以及升级套餐。']
}, {
  title: '游戏地图：',
  content: ['游戏全程共需要完成34个省市地图，每个省市地图有效期为7天，7天内达成公里数目标即为完成该地图。', '省市地图目标公里数初始默认10公里，随时可修改，在不同情况下修改会有不同的结果。公里数设置后，后面再开启的地图会延续此设置。记得修改后点击“确定”按钮！<br /> 1）在地图中未前进过：目标公里数修改后，即时生效！<br /> 2）在地图中已前进过：目标公里数修改后，在下一个地图生效！ ', '目标公里数为累积完成，不同公里数完成地图所用的时间也不一样，公里数越大，完成地图所需时间就越长。', '游戏内的省市地图为虚构地图，地图内展现的是该省市内所有特色建筑、美食人文、古迹集合。']
}, {
  title: '游戏玩法：',
  content: ['通过“百日跑”公众号内跑步打卡，所得公里数累积在省市地图中的“前进”按钮中，手动点击“前进”按钮才能在地图上前进。解锁地标、完成每日任务均可获得拼图奖励。', '每人每天跑步打卡累计超过5公里，那么只会取5公里计入该游戏的累计！', '“前进“按钮中累积的公里数每日24点会清空，跑步打卡后请及时使用。', '追梦中国完整一轮游戏时间为238天，一轮完成后再开启新的一轮（循环赛制），每完成一轮后可对遗漏和未完成的地图进行补玩，一轮结束后，用户手动重置游戏后，即可进入用户的第二轮游戏。', '报名带有奖牌套餐的用户，在一轮游戏中只要省市地图完成数量达成30个，即可获得实物奖牌。如果一轮游戏后未达成奖牌任务就重置游戏，则在本轮不能获得奖牌。用户可再开启一轮游戏，完成奖牌任务后仍可获得奖牌。', '完成一轮结束后 (238天) ，可以点击其中任意一个“未完成”的地图进行补玩，出现补漏弹窗，确定后进入该省市地图游戏页，跑步打卡后点击“前进”按钮，玩法不变。每次只能补玩1个，完成一个才能开启下一个，其他规则周期时间均不变。']
}, {
  title: '游戏奖励：',
  content: ['游戏中奖励分为虚拟奖品、数字藏品、独脚潘课程、和实物奖牌', '数字藏品和独脚潘课程奖励的发放，需要通过收集拼图碎片并且拼图成功，来获得领取或购买资格，如需购买请在游戏中付费后进行领取和查看。']
}, {
  title: '功能说明：',
  content: ['游戏被“重置”后，会清空游戏内所有数据和虚拟奖励，其中已获得和购买的数字藏品和独脚潘课程还存在，<span class="FF1111">可以继续查看</span>', '重置游戏后，当前进行中的地图不可继续玩，并且地图状态变为未解锁，需等待下个新地图开启后再开始游戏。<span class="FF1111">（重置需谨慎）</span> 具体功能的开启和关闭以活动界面显示为准。', '游戏中拼图碎片有“赠卡”和“求卡”功能，通过在游戏中复制链接，并在微信中发送给其他微信好友，新用户进入后直接跳转至【赛事详情页】进行报名，已报名用户进入后可直接领取卡片。']
}, {
  title: '关于奖牌：',
  content: ['实物奖牌只能获得一次，再次达成30省市任务后获得虚拟奖牌/电子证书']
}]; // 每7天一个城市

export var GAME_CYCLE = 7;
export var TOTAL_DAYS = 238;
export var zmzgDefaultTestImg = 'https://growth-test.oss-cn-beijing.aliyuncs.com/material/image/2021-02-15/182927-ZLxRF2.jpeg';
var STATIC_HOST = 'https://static.run100.runorout.cn';
export var STATIC_HOST_DREAM = STATIC_HOST + "/static/img/dream";
export var STATIC_HOST_META = STATIC_HOST + "/meta";
export var STATIC_HOST_DREAM_CITY = STATIC_HOST_DREAM + "/city";
export function getDreamImg(name) {
  return STATIC_HOST + "/static/img/dream/" + name;
}
export function getLocationDreamImg(name) {
  return require("@/assets/images/dream/" + name);
}
export function getDreamCityImg(name) {
  return getDreamImg("city/" + name);
}